var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[(_vm.loaded)?[[_c('dr-icon',{attrs:{"name":"starAvaliacao","color":"#ffb700"}}),_vm._v(" "),_c('span',{staticClass:"grade"},[_vm._v("\n        "+_vm._s(_vm.grade)+"\n      ")])]]:_c('dr-loader')],2)}
var staticRenderFns = []

export { render, staticRenderFns }